import { Check, X } from "lucide-react";

interface ServiceItem {
  name: string;
  included: boolean;
  highlight?: boolean;
}

interface ServiceComparisonProps {
  title: string;
  services: ServiceItem[];
  description?: string;
}

export function ServicesComparison({ title, services, description }: ServiceComparisonProps) {
  const included = services.filter(s => s.included);
  const excluded = services.filter(s => !s.included);

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden flex flex-col">
      {/* Header */}
      <div className="bg-brand-primary px-6 py-5">
        <h3 className="text-lg font-bold text-white font-primary">{title}</h3>
        {description && (
          <p className="text-white/70 text-sm mt-1 leading-snug">{description}</p>
        )}
      </div>

      {/* Items */}
      <ul className="flex-1 divide-y divide-gray-50">
        {services.map((item, i) => {
          const isHighlight = item.highlight ?? item.name.toLowerCase().startsWith("tudo do");
          return (
            <li key={i} className={`flex items-center gap-3 px-5 py-3 ${item.included ? "" : "opacity-50"} ${isHighlight ? "bg-brand-primary/5" : ""}`}>
              <span className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${isHighlight ? "bg-brand-primary/15" : item.included ? "bg-emerald-50" : "bg-gray-100"}`}>
                {item.included
                  ? <Check className={`w-3 h-3 ${isHighlight ? "text-brand-primary" : "text-emerald-600"}`} strokeWidth={2.5} />
                  : <X className="w-3 h-3 text-gray-400" strokeWidth={2.5} />}
              </span>
              <span className={`text-sm ${isHighlight ? "text-brand-primary font-semibold" : item.included ? "text-gray-700" : "text-gray-400 line-through"}`}>
                {item.name}
              </span>
            </li>
          );
        })}
      </ul>

      {/* Footer pill */}
      <div className="px-5 py-4 bg-gray-50 border-t border-gray-100">
        <p className="text-xs text-gray-400 font-medium">
          <span className="text-brand-primary font-semibold">{included.length}</span> itens incluídos
          {excluded.length > 0 && (
            <span className="ml-1">· {excluded.length} não incluídos</span>
          )}
        </p>
      </div>
    </div>
  );
}
